import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentUserUpdatePersonalInfoResponse {
  message: string;
};

// 请求接口
export interface AgentUserUpdatePersonalInfoRequest {
  agentId: string;
  subUserName: string;
  introduction: string;
  personalTitle: string;
  subAvatar: string;
}


export class AgentUserUpdatePersonalInfoData {
  // @Required("message cannot be empty")
  @IsString("message must be a string")
  message: string;
}

const transformAndValidateAgent = (
  response: AgentUserUpdatePersonalInfoResponse
): AgentUserUpdatePersonalInfoData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentUserUpdatePersonalInfoData);
  } catch (error) {
    console.error("Agent User Update Personal Info data validation failed:", error.message);
    throw error;
  }
};

/** 更新指定智能体下的用户子信息 */
export const agentUserUpdatePersonalInfo = async ({ agentId, subUserName, introduction, personalTitle, subAvatar }: AgentUserUpdatePersonalInfoRequest): Promise<AgentUserUpdatePersonalInfoData> => {  
  const response = await api.post<AgentUserUpdatePersonalInfoResponse>('/agent/user/subinfo/update-personal-info', {
    agent_id: agentId,
    sub_user_name: subUserName,
    introduction: introduction,
    personal_title: personalTitle,
    sub_avatar: subAvatar,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
